import qs from 'qs'
import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '@/_metronic/helpers'
import {dateStr} from '../../helpers'
import {SponsorshipIndicators, SourceData, EvolutionsData} from './_models'

const BASE_URL = `/p2c/reports/sponsorship`

/**
 * buildQs.
 *
 * @param {Date} from
 * @param {Date} to
 * @param {ID} sponsor
 * @returns {string}
 */
const buildQs = (from: Date, to?: Date, sponsor?: ID): string => {
  const query: { [key: string]: any } = {
    from: dateStr(from)
  }

  if (sponsor) {
    query.sponsor = sponsor
  }

  if (to) {
    query.to = dateStr(to)
  }

  return qs.stringify(query)
}

/**
 * getIndicators.
 *
 * @param {Date} from
 * @param {Date} to
 * @param {ID} sponsor
 * @returns {Promise<SponsorshipIndicators | undefined>}
 */
const getIndicators = (from: Date, to?: Date, sponsor?: ID) : Promise<SponsorshipIndicators | undefined> => {
  const query = buildQs(from, to, sponsor)

  return axios
    .get(`${BASE_URL}/indicators?${query}`)
    .then((response: AxiosResponse<Response<SponsorshipIndicators>>) => response.data)
    .then((response: Response<SponsorshipIndicators>) => response.data)
}

/**
 * getSourcesRepartition.
 *
 * @param {Date} from
 * @param {Date} to
 * @param {ID} sponsor
 * @returns {Promise<Array<SourceData>>}
 */
const getSourcesRepartition = (from: Date, to?: Date, sponsor?: ID) : Promise<Array<SourceData>> => {
  const query = buildQs(from, to, sponsor)

  return axios
    .get(`${BASE_URL}/sources-repartition?${query}`)
    .then((d: AxiosResponse<Response<Array<SourceData>>>) => d.data)
    .then((d: Response<Array<SourceData>>) => d.data || [])
}

/**
 * getEvolution.
 *
 * @param {Date} from
 * @param {Date} to
 * @param {ID} sponsor
 * @returns {Promise<EvolutionsData>}
 */
const getEvolution = (from: Date, to?: Date, sponsor?: ID) : Promise<EvolutionsData> => {
  const query = buildQs(from, to, sponsor)

  return axios
    .get(`${BASE_URL}/evolution?${query}`)
    .then((d: AxiosResponse<Response<EvolutionsData>>) => d.data)
    .then((d: Response<EvolutionsData>) => d.data || {
      affiliates: [],
      clicks: [],
      earnings: []
    })
}

export {
  getIndicators,
  getSourcesRepartition,
  getEvolution
}
